const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_minimal/settings/cancel-plan.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { checkIfProtectedRouteCanBeSeen } from "@/react/components/shared/ProtectedRoute/useProtectedRoute";
import { isPlanPlus } from "@/react/helpers/planHelpers";
export const Route = createFileRoute("/_minimal/settings/cancel-plan")({
  beforeLoad: ({
    context,
    location
  }) => {
    const currentCommunity = context.punditUserContext?.currentCommunity;
    const canSeeProtectedRoute = checkIfProtectedRouteCanBeSeen(location.pathname, currentCommunity);
    const canCancelPlan = Boolean(currentCommunity?.subscription && !currentCommunity.subscription.ends_at && !isPlanPlus(currentCommunity.current_plan_tier));
    if (!canSeeProtectedRoute || !canCancelPlan) {
      redirect({
        to: "/settings/plans",
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});